module.exports = __webpack_public_path__ + "img/011.0003f7cd.jpg";